import styled from 'styled-components';

import { spaceXXL } from '@xingternal/tokens';
import { Column } from '@xingternal/xing-grid';

export const StyledColumn = styled(Column)`
  margin-right: ${spaceXXL};
`;

export const StyledHeader = styled.div`
  line-height: normal;
  word-break: break-word;
`;
